import styled from "styled-components";
import { device } from "../../Utils/device";
import { themes } from "../../Utils/themes";

export const TelWrap = styled.div`
  color: ${themes.colors.text};
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 10px;
  white-space: nowrap;

  @media ${device.desktop} {
    align-items: flex-start;
    gap: 4px;
  }
`;

/* SP: 枠線付きの押せるボタン / PC: ラベル＋値の整列表示 */
export const ContactRow = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 11px 16px;
  border: 1.5px solid ${themes.colors.primary};
  border-radius: 9999px;
  color: ${themes.colors.primary};
  font-weight: bold;
  text-decoration: none;
  transition: background-color 0.2s ease, color 0.2s ease;

  &:active {
    background-color: ${themes.colors.primary};
    color: ${themes.colors.white};
  }

  @media ${device.desktop} {
    display: grid;
    grid-template-columns: 3em auto;
    justify-content: start;
    column-gap: 4px;
    padding: 3px 0;
    border: none;
    border-radius: 0;
    color: ${themes.colors.text};

    &:hover {
      color: ${themes.colors.primary};
    }
    &:active {
      background-color: transparent;
      color: ${themes.colors.primary};
    }
  }
`;

export const ContactIcon = styled.img`
  width: 16px;
  height: 16px;
  flex-shrink: 0;

  @media ${device.desktop} {
    display: none;
  }
`;

/* SP のみ表示するボタン文言 */
export const ContactAction = styled.span`
  font-size: ${themes.textSize.s3};

  @media ${device.desktop} {
    display: none;
  }
`;

/* PC のみ表示するラベル・値・受付時間 */
export const ContactLabel = styled.span`
  display: none;

  @media ${device.desktop} {
    display: inline;
    font-size: ${themes.textSize.s2};
    color: ${themes.colors.text};
  }
`;

export const ContactValue = styled.span`
  display: none;

  @media ${device.desktop} {
    display: inline;
    font-size: ${themes.textSize.s3};
    font-weight: bold;
    letter-spacing: 0.02em;
  }
`;

export const TelDescription = styled.p`
  align-self: center;
  text-align: center;
  font-size: ${themes.textSize.s1};
  color: ${themes.colors.text};

  @media ${device.desktop} {
    align-self: flex-start;
    text-align: left;
    /* PC: ラベル列 + gap の分だけ字下げして値に揃える */
    padding-left: calc(3em + 4px);
  }
`;
